import { useEffect } from 'react'
import { useTravelSearchContext } from '../../context/TravelSearchProvider'
import { getBaseApi } from '../../Utils/common'
import { getUnlocodeFromRouteCode } from '../../Utils/unlocode-mapper'
import { fetcher } from '../../Utils/fetcher'
import { VehicleTypesResponse } from './vehicle-types'

export function useLoadVehiclesIntoContext(offerCode?: string) {
  const { state, dispatch } = useTravelSearchContext()

  useEffect(() => {
    if (!state.selectedRoute?.routeCode || !state.selectedRoute.salesOwner) return

    const fetchVehicles = async () => {
      dispatch({ type: 'SET_VEHICLE_API_LOADING', payload: true })

      const baseApi = getBaseApi()
      const route = getUnlocodeFromRouteCode(state.selectedRoute?.routeCode ?? '')
      const offerOrProductCode = state.routesApiData?.offerOrProductCode || offerCode || ''
      const url = `${baseApi}/vehicle-types?salesOwner=${state.selectedRoute?.salesOwner ?? ''}&route=${route}&offerOrProductCode=${offerOrProductCode}`

      try {
        const data: VehicleTypesResponse = await fetcher(url)
        dispatch({ type: 'SET_VEHICLE_API_DATA', payload: data })
      } finally {
        dispatch({ type: 'SET_VEHICLE_API_LOADING', payload: false })
      }
    }

    fetchVehicles()
  }, [state.selectedRoute?.routeCode, state.selectedRoute?.salesOwner, state.routesApiData?.offerOrProductCode, offerCode])
}
